module.exports = __webpack_public_path__ + "static/media/01B.4d18a2c7.png";